/*
 * @Description:网货票
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2024-04-24 14:10:46
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import { postQueryTradeInfo, getAccountCenterQueryCondition } from '@/api/account';
import { formatMoneyConvert } from '@/utils';
import moment from 'moment';

const storeModuleName = 'transactionNetGoodsModule';

const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'paymentPlatformCode',
      value: '',
      valueType: 'string',
      state: 'paymentPlatforms',
      label: '收款方',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'businessType',
      value: '',
      valueType: 'string',
      state: 'businessTypes',
      label: '交易类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'tradeType',
      value: '',
      valueType: 'string',
      state: 'tradeTypes',
      label: '收支类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },

    {
      style: 'date-picker',
      param: 'tradeTime',
      value: [],
      valueType: 'date',
      label: '交易时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['tradeStartDate', 'tradeEndDate'],
    },
  ],
  // 导出
  isExport: false,
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '交易编号',
        prop: 'transNumber',
        width: 140,
        fixed: 'left',
        checked: 1,
        sortable: true,
      },
      {
        label: '交易类型',
        prop: 'businessTypeLabel',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '收支类型',
        prop: 'tradeType',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-tradeType',
      },
      {
        label: '交易金额（元）',
        prop: 'settlementAmount',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-settlementAmount',
      },
      {
        label: '余额（元）',
        prop: 'tranAfterAmt',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '交易时间',
        prop: 'settlementDate',
        width: 140,
        checked: 1,
        sortable: true,
      },
      {
        label: '付款方',
        prop: 'outAcctName',
        width: 140,
        checked: 1,
        sortable: true,
      },
      {
        label: '收款方',
        prop: 'paymentPlatformName',
        width: 140,
        checked: 1,
        sortable: true,
      },
      {
        label: '支付批次号',
        prop: 'batchId',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-batchId',
      },
    ],
  },
  businessId: '', // 所选企业ID
  businessTypes: [], // 交易类型
  paymentPlatforms: [], // 收款平台
  tradeTypes: [], // 收支类型
  statisticsTxt: '', // 统计信息展示
};

// getters
const getters = {};

// actions
const actions = {
  // 获取筛选项数据
  getParams: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    return params;
  },
  // 获取列表数据
  getList: async context => {
    // 列表展示数据
    const params = await context.dispatch('getParams');
    const { data } = await postQueryTradeInfo(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    // 统计信息
    const abs = true;
    const statisticsTxt = `共计：${data.statistics.total}条；其中：收入：${
      data.statistics.incomeTotal
    }条，${formatMoneyConvert({
      money: data.statistics.incomeAmount * 100,
      abs,
    })}元；支出：${data.statistics.expenseTotal}条、${formatMoneyConvert({
      money: data.statistics.expenseAmount * 100,
      abs,
    })}元；差额：${formatMoneyConvert({
      money: data.statistics.differenceAmount * 100,
    })}元`;
    context.commit('updateState', {
      key: 'statisticsTxt',
      value: statisticsTxt,
    });
    return data.list;
  },
  // 获取筛选条件
  getQueryCondition: async context => {
    const { code, data } = await getAccountCenterQueryCondition({
      businessId: context.state.businessId,
    });
    if (code === 200) {
      const businessTypes = data['businessType'] || []; // 交易类型
      const paymentPlatforms = data['paymentPlatform'] || []; // 收款方
      const tradeTypes = data['tradeType'] || []; // 收支类型
      context.commit('updateState', {
        key: 'paymentPlatforms',
        value: paymentPlatforms,
      });
      context.commit('updateState', {
        key: 'businessTypes',
        value: businessTypes,
      });
      context.commit('updateState', {
        key: 'tradeTypes',
        value: tradeTypes,
      });
    }
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        if (item.param === 'tradeTime') {
          item.value = [
            moment().subtract(30, 'day').format('yyyy-MM-DD'),
            moment().format('yyyy-MM-DD'),
          ];
        } else {
          item.value = [];
        }
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
